import { UhcSemiBold } from "@src/apps/styles/common-style";

export const COMMON_CARD_CANCELED_PREFIX = 'Canceled:';

export const chartData=[
    [
        {
            "name": "Mar",
            "ind": 3,
            "value": 194851,
            "year": "2023"
        },
        {
            "name": "Apr",
            "ind": 4,
            "value": 170505,
            "year": "2023"
        },
        {
            "name": "May",
            "ind": 5,
            "value": 191773,
            "year": "2023"
        },
        {
            "name": "Jun",
            "ind": 6,
            "value": 199098,
            "year": "2023"
        },
        {
            "name": "Jul",
            "ind": 7,
            "value": 179922,
            "year": "2023"
        },
        {
            "name": "Aug",
            "ind": 8,
            "value": 199223,
            "year": "2023"
        },
        {
            "name": "Sep",
            "ind": 9,
            "value": 180818,
            "year": "2023"
        },
        {
            "name": "Oct",
            "ind": 10,
            "value": 204751,
            "year": "2023"
        },
        {
            "name": "Nov",
            "ind": 11,
            "value": 174853,
            "year": "2023"
        },
        {
            "name": "Dec",
            "ind": 12,
            "value": 150073,
            "year": "2023"
        },
        {
            "name": "Jan",
            "ind": 1,
            "value": 219362,
            "year": "2024"
        },
        {
            "name": "Feb",
            "ind": 2,
            "value": 120557,
            "year": "2024"
        }
    ],
    [
        {
            "name": "Mar",
            "ind": 3,
            "value": 117674,
            "year": "2023"
        },
        {
            "name": "Apr",
            "ind": 4,
            "value": 102572,
            "year": "2023"
        },
        {
            "name": "May",
            "ind": 5,
            "value": 65460,
            "year": "2023"
        },
        {
            "name": "Jun",
            "ind": 6,
            "value": 46029,
            "year": "2023"
        },
        {
            "name": "Jul",
            "ind": 7,
            "value": 43774,
            "year": "2023"
        },
        {
            "name": "Aug",
            "ind": 8,
            "value": 50836,
            "year": "2023"
        },
        {
            "name": "Sep",
            "ind": 9,
            "value": 45222,
            "year": "2023"
        },
        {
            "name": "Oct",
            "ind": 10,
            "value": 51865,
            "year": "2023"
        },
        {
            "name": "Nov",
            "ind": 11,
            "value": 41379,
            "year": "2023"
        },
        {
            "name": "Dec",
            "ind": 12,
            "value": 33681,
            "year": "2023"
        },
        {
            "name": "Jan",
            "ind": 1,
            "value": 41854,
            "year": "2024"
        },
        {
            "name": "Feb",
            "ind": 2,
            "value": 36682,
            "year": "2024"
        }
    ],
    [
        {
            "name": "Mar",
            "ind": 3,
            "value": 13869,
            "year": "2023"
        },
        {
            "name": "Apr",
            "ind": 4,
            "value": 12104,
            "year": "2023"
        },
        {
            "name": "May",
            "ind": 5,
            "value": 16637,
            "year": "2023"
        },
        {
            "name": "Jun",
            "ind": 6,
            "value": 33430,
            "year": "2023"
        },
        {
            "name": "Jul",
            "ind": 7,
            "value": 30909,
            "year": "2023"
        },
        {
            "name": "Aug",
            "ind": 8,
            "value": 24283,
            "year": "2023"
        },
        {
            "name": "Sep",
            "ind": 9,
            "value": 28542,
            "year": "2023"
        },
        {
            "name": "Oct",
            "ind": 10,
            "value": 29920,
            "year": "2023"
        },
        {
            "name": "Nov",
            "ind": 11,
            "value": 18445,
            "year": "2023"
        },
        {
            "name": "Dec",
            "ind": 12,
            "value": 21857,
            "year": "2023"
        },
        {
            "name": "Jan",
            "ind": 1,
            "value": 24225,
            "year": "2024"
        },
        {
            "name": "Feb",
            "ind": 2,
            "value": 24926,
            "year": "2024"
        }
    ],
    [
        {
            "name": "Mar",
            "ind": 3,
            "value": 36168,
            "year": "2023"
        },
        {
            "name": "Apr",
            "ind": 4,
            "value": 31177,
            "year": "2023"
        },
        {
            "name": "May",
            "ind": 5,
            "value": 32561,
            "year": "2023"
        },
        {
            "name": "Jun",
            "ind": 6,
            "value": 27282,
            "year": "2023"
        },
        {
            "name": "Jul",
            "ind": 7,
            "value": 24318,
            "year": "2023"
        },
        {
            "name": "Aug",
            "ind": 8,
            "value": 28417,
            "year": "2023"
        },
        {
            "name": "Sep",
            "ind": 9,
            "value": 23618,
            "year": "2023"
        },
        {
            "name": "Oct",
            "ind": 10,
            "value": 25716,
            "year": "2023"
        },
        {
            "name": "Nov",
            "ind": 11,
            "value": 22490,
            "year": "2023"
        },
        {
            "name": "Dec",
            "ind": 12,
            "value": 18755,
            "year": "2023"
        },
        {
            "name": "Jan",
            "ind": 1,
            "value": 26538,
            "year": "2024"
        },
        {
            "name": "Feb",
            "ind": 2,
            "value": 24573,
            "year": "2024"
        }
    ],
    [
        {
            "name": "Mar",
            "ind": 3,
            "value": 26755,
            "year": "2023"
        },
        {
            "name": "Apr",
            "ind": 4,
            "value": 24287,
            "year": "2023"
        },
        {
            "name": "May",
            "ind": 5,
            "value": 76665,
            "year": "2023"
        },
        {
            "name": "Jun",
            "ind": 6,
            "value": 91827,
            "year": "2023"
        },
        {
            "name": "Jul",
            "ind": 7,
            "value": 80548,
            "year": "2023"
        },
        {
            "name": "Aug",
            "ind": 8,
            "value": 95260,
            "year": "2023"
        },
        {
            "name": "Sep",
            "ind": 9,
            "value": 83010,
            "year": "2023"
        },
        {
            "name": "Oct",
            "ind": 10,
            "value": 96867,
            "year": "2023"
        },
        {
            "name": "Nov",
            "ind": 11,
            "value": 92196,
            "year": "2023"
        },
        {
            "name": "Dec",
            "ind": 12,
            "value": 75495,
            "year": "2023"
        },
        {
            "name": "Jan",
            "ind": 1,
            "value": 126352,
            "year": "2024"
        },
        {
            "name": "Feb",
            "ind": 2,
            "value": 34038,
            "year": "2024"
        }
    ]
]
export const generalDataDetails=[
    {
      backgroundColor: null,
      barColor: '#082D6A',
      trendIndicator: 'dotted-bar3',
      label: 'Total',
      monStart:'jan',
      barGraphNumberSize: 18,
      hideYAxis: false,
      tooltipBoolean: true,
      width: 961,
      height: 270,
      yAxisUnits: '',
    },
    {
        backgroundColor: null,
        barColor: '#003DA1',
        trendIndicator: 'solid-bar3',
        label: 'Claims',
        monStart:'jan',
        barGraphNumberSize: 18,
        hideYAxis: false,
        tooltipBoolean: true,
        width: 961,
        height: 270,
        yAxisUnits: '',
      },
    {
        backgroundColor: null,
        barColor: '#80B0FF',
        trendIndicator: 'solid-bar3',
        label: 'Prior Authorizations',
        monStart:'jan',
        barGraphNumberSize: 18,
        hideYAxis: false,
        tooltipBoolean: true,
        width: 961,
        height: 270,
        yAxisUnits: '',
      },

    {
      backgroundColor: null,
      barColor: '#003DA1',
      trendIndicator: 'solid-bar3',
      label: 'Referrals',
      monStart:'jan',
      barGraphNumberSize: 18,
      hideYAxis: false,
      tooltipBoolean: true,
      width: 961,
      height: 270,
      yAxisUnits: '',
    },

    {
      backgroundColor: null,
      barColor: '#8E6EDD',
      trendIndicator: 'solid-bar3',
      label: 'Eligibility',
      monStart:'jan',
      barGraphNumberSize: 18,
      hideYAxis: false,
      tooltipBoolean: true,
      width: 961,
      height: 270,
      yAxisUnits: '',
    }]

    export const metricCardDetails={
        status:null,
        cards:[
        {
            "status": null,
            "header":'Reduce Operating     Cost of Calls By:',
            "title": null,
            "type": "radio-tile-card",
            "total": "$342.8K",
            "width": "160px",
            "enable":true,
            "cardValues": [
                {
                    "value": "1$",
                    "name": "Digital Solutions (avg.)",
                    "navigateTo": null,
                    "linkName": null
                },
                {
                    "value": "5$",
                    "name": "Phone call (avg.)",
                    "navigateTo": null,
                    "linkName": null
                },
                {
                    "value": null,
                    "name": "",
                    "navigateTo": "/service-interaction/calls",
                    "linkName": "View Calls Details"
                }
            ]
        },
        {
            "status": null,
            "header":"Save Your Staff's Time By (Total Over 3 Months):",
            "title": null,
            "type": "radio-tile-card",
            "total": "70 Hours",
            "enable":true,
            "cardValues": [
                {
                    "value": "12 Hours",
                    "name": "Digital Solutions (avg.)",
                    "navigateTo": null,
                    "linkName": null
                },
                {
                    "value": "82 Hours",
                    "name": "Phone call (avg.)",
                    "navigateTo": null,
                    "linkName": null
                },

            ]
        },
        {
            "status": null,
            "header":'Reduce Reconsideration Processing By:',
            "title": null,
            "type": "radio-tile-card",
            "total": "11 Days",
            "enable":true,
            "cardValues": [
                {
                    "value": "39 Days",
                    "name": "Digital Solutions (avg.)",
                    "navigateTo": null,
                    "linkName": null
                },
                {
                    "value": "50 Days",
                    "name": "Mail (avg.)",
                    "navigateTo": null,
                    "linkName": null
                },
            ]
        },
        {
            "status": null,
            "header":'Reduce Claim Processing Time By:',
            "title": null,
            "type": "radio-tile-card",
            "total": "17 Days",
            "enable":true,
            "cardValues": [
                {
                    "value": "23 Days",
                    "name": "Digital Solutions (avg.)",
                    "navigateTo": null,
                    "linkName": null
                },
                {
                    "value": "50 Days",
                    "name": "Mail (avg.)",
                    "navigateTo": null,
                    "linkName": null
                },
            ]
        }
    ]}
    export const chipDetails = [
        { value: 'All Selected Tins', title: 'All', selected: true, highlighted:true },
        {
            value: '10858704',
            title: '8FORT PIERCE ORTHOPAEDICS',
            selected: true,
            highlighted:false
          },
          {
            value: '230573692',
            title: '2OCCUPATIONAL AND FAMILY MED OF TEXAS IN',
            selected: true,
            highlighted:false
          },
          {
            value: '30858707',
            title: '3FORT PIERCE ORTHOPAEDICS',
            selected: true,
            highlighted:false
          },
          {
            value: '430573699',
            title: '4OCCUPATIONAL AND FAMILY MED OF TEXAS IN',
            selected: true,
            highlighted:false
          },
          {
            value: '50858707',
            title: '5FORT PIERCE ORTHOPAEDICS',
            selected: true,
            highlighted:false
          },
          {
            value: '630573699',
            title: '6OCCUPATIONAL AND FAMILY MED OF TEXAS IN',
            selected: true,
            highlighted:false
          }
      ];
    //   export const chipDetails = [
    //     { value: 'All Selected Tins', title: 'All', selected: false, highlighted:true },
    //     {
    //         value: '10858704',
    //         title: '8FORT PIERCE ORTHOPAEDICS',
    //         selected: false,
    //         highlighted:false
    //       },
    //       {
    //         value: '230573692',
    //         title: '2OCCUPATIONAL AND FAMILY MED OF TEXAS IN',
    //         selected: false,
    //         highlighted:false
    //       },
    //       {
    //         value: '30858707',
    //         title: '3FORT PIERCE ORTHOPAEDICS',
    //         selected: false,
    //         highlighted:false
    //       },
    //       {
    //         value: '430573699',
    //         title: '4OCCUPATIONAL AND FAMILY MED OF TEXAS IN',
    //         selected: false,
    //         highlighted:false
    //       },
    //       {
    //         value: '50858707',
    //         title: '5FORT PIERCE ORTHOPAEDICS',
    //         selected: false,
    //         highlighted:false
    //       },
    //       {
    //         value: '630573699',
    //         title: '6OCCUPATIONAL AND FAMILY MED OF TEXAS IN',
    //         selected: false,
    //         highlighted:false
    //       }
    //   ];

    export const activeExemptionhead=[{name:'Category', width:'102px', hide:false},{name:'Key Measure', width:'118px', hide:false}, {name:'Effective to End Date', width:'88px', hide:false},
    {name:'Fully Insured Dollar Value', width:'80px', hide:false},{name:'Reason', width:'105px', hide:false}, {name:'Facility/ Physician', width:'76px', hide:false},
    {name:'Requestor Name', width:'146px', hide:false}]

    export const activeExemptionTabelDetails=[[[{name:'Clinical', link:false}],
    [{name:'SOS Surgical', link:true}],
    [{name:'04/01/2024 – ', link:false},{name:'No End Date', link:false}],
    [{name:'$350K', link:false}],
    [{name:'N/A', link:false}],
    [{name:'N/A', link:false}],
    [{name:'First Name Last Name', link:false}]],

    [[{name:'Payment Integrity', link:false}],
    [{name:'Non-Clinical', link:false},{name:'Non-Standard', link:false},{name:'Contract Language', link:false}],
    [{name:'04/01/2024 – ', link:false},{name:'No End Date', link:false}],
    [{name:'$350K', link:false}],
    [{name:'Achieved Rate Reduction', link:false}],
    [{name:'Facility: Y', link:false},{name:'Physician: N', link:false}],
    [{name:'First Name Last Name1', link:false},{name:'First Name Last Name2', link:false}]],

    [[{name:'Network', link:false}],
    [{name:'Same Day', link:false},{name:'Same Service', link:false}],
    [{name:'04/01/2024 – ', link:false},{name:'No End Date', link:false}],
    [{name:'$350K', link:false}],
    [{name:'View Details', link:true, outSideSite:true, siteStorageKey: 'dontShowReimbursementPolicyExclusion', siteLink: 'https://uhgazure.sharepoint.com/sites/PPOneVision/RPU2U/Pages/Reimbursement-Policy-Exclusion-List.aspx?'}],
    [{name:'N/A', link:false}],
    [{name:'First Name Last Name', link:false}]]
]

export const nonExemptionhead=[{name:'Category', width:'102px', hide:false},{name:'Key Measure', width:'118px', hide:false}, {name:'Time Period', width:'88px', hide:false},
{name:'Fully Insured Dollar Value', width:'80px', hide:false}]

export const nonExemptionTabelDetails=[[[{name:'Other', link:false}],
[{name:'Hospital Ref Lab', link:true}],
[{name:'04/01/2023 – 03/31/2024', link:false}],
[{name:'$350K', link:false}]],

[[{name:'Other', link:false}],
[{name:'CLIA – Pause', link:true}],
[{name:'04/01/2023 – 03/31/2024', link:false}],
[{name:'$350K', link:false}]]
]

export const  hcoExemption = {
    status: null,
    cards: [
      {
        status: null,
        header: 'Clinical (9)',
        width: '117px',
        activeExemption:true,
        cardValues: [
          {
            value: '3',
            name: 'GI Endoscopy',
            taxIdDetails:[{
              taxId:'1234567899',
              taxName:'Tax ID Group Name Goes Here'
            },
            {
              taxId:'1234567889',
              taxName:'Tax ID Group Name Goes Here'
            },
            {
              taxId:'1234567789',
              taxName:'Tax ID Group Name Goes Here'
            },
          ]
          },
          {
            value: '3',
            name: 'SOS Surgical',
            taxIdDetails:[{
              taxId:'1234566789',
              taxName:'Tax ID Group Name Goes Here'
            },
            {
              taxId:'1234556789',
              taxName:'Tax ID Group Name Goes Here'
            },
            {
              taxId:'1234456789',
              taxName:'Tax ID Group Name Goes Here'
            },
          ]
          },
          {
            value: '3',
            name: 'Hospital Observation <8 hours',
            taxIdDetails:[{
              taxId:'123456789',
              taxName:'Tax ID Group Name Goes Here'
            },
            {
              taxId:'123456789',
              taxName:'Tax ID Group Name Goes Here'
            },
            {
              taxId:'123456789',
              taxName:'Tax ID Group Name Goes Here'
            },
          ]
          },
        ],
      },
      {
        status: null,
        header: 'Competitiveness',
        width: '133px',
        activeExemption:false,
        cardValues: [
        ],
      },
      {
        status: null,
        header: 'Payment Integrity',
        width: '144px',
        activeExemption:true,
        cardValues: [
          {
            value: '3',
            name: 'Level of Care/Level of Stay (LOC/LOS)',
            taxIdDetails:[{
              taxId:'123456789',
              taxName:'Tax ID Group Name Goes Here'
            },
            {
              taxId:'123456789',
              taxName:'Tax ID Group Name Goes Here'
            },
            {
              taxId:'123456789',
              taxName:'Tax ID Group Name Goes Here'
            },
          ]
          },
          {
            value: '2',
            name: 'Designated Data Steward (aka, roster manager role)',
            taxIdDetails:[{
              taxId:'123456789',
              taxName:'Tax ID Group Name Goes Here'
            },
            {
              taxId:'123456789',
              taxName:'Tax ID Group Name Goes Here'
            }
          ]
          }
        ],
      },
      {
        status: null,
        header: 'Network',
        width: '126px',
        activeExemption:false,
        cardValues: [
        ],
      },
      {
        status: null,
        header: 'Pharmacy',
        width: '140px',
        activeExemption:false,
        cardValues: [ ],
      }
    ],
  };

export const  exemptionStatusDetails = [{
    taxDetails:{
        taxID:'423456789',
        taxIdGroupName:'ID Group Name Goes Here'
    },
    activeExpiringExemption:{
        count:2
    },
    nomExemption:{
        count:2
    },
    viewDetails:{
        totalCount:1,
        view:true
    }
},
{
    taxDetails:{
        taxID:'123456789',
        taxIdGroupName:'ID Group Name Goes Here'
    },
    activeExpiringExemption:{
        count:3
    },
    nomExemption:{
        count:3
    },
    viewDetails:{
        totalCount:1,
        view:true
    }
},
{
    taxDetails:{
        taxID:'423456789',
        taxIdGroupName:'ID Group Name Goes Here'
    },
    activeExpiringExemption:{
        count:2
    },
    nomExemption:{
        count:2
    },
    viewDetails:{
        totalCount:1,
        view:true
    }
},
{
    taxDetails:{
        taxID:'123456789',
        taxIdGroupName:'ID Group Name Goes Here'
    },
    activeExpiringExemption:{
        count:3
    },
    nomExemption:{
        count:3
    },
    viewDetails:{
        totalCount:1,
        view:true
    }
},
{
    taxDetails:{
        taxID:'423456789',
        taxIdGroupName:'ID Group Name Goes Here'
    },
    activeExpiringExemption:{
        count:2
    },
    nomExemption:{
        count:2
    },
    viewDetails:{
        totalCount:1,
        view:true
    }
},
{
    taxDetails:{
        taxID:'123456789',
        taxIdGroupName:'ID Group Name Goes Here'
    },
    activeExpiringExemption:{
        count:3
    },
    nomExemption:{
        count:3
    },
    viewDetails:{
        totalCount:1,
        view:true
    }
},
{
    taxDetails:{
        taxID:'423456789',
        taxIdGroupName:'ID Group Name Goes Here'
    },
    activeExpiringExemption:{
        count:2
    },
    nomExemption:{
        count:2
    },
    viewDetails:{
        totalCount:1,
        view:true
    }
},
{
    taxDetails:{
        taxID:'123456789',
        taxIdGroupName:'ID Group Name Goes Here'
    },
    activeExpiringExemption:{
        count:3
    },
    nomExemption:{
        count:3
    },
    viewDetails:{
        totalCount:1,
        view:true
    }
},
{
    taxDetails:{
        taxID:'423456789',
        taxIdGroupName:'ID Group Name Goes Here'
    },
    activeExpiringExemption:{
        count:2
    },
    nomExemption:{
        count:2
    },
    viewDetails:{
        totalCount:1,
        view:true
    }
},
{
    taxDetails:{
        taxID:'123456789',
        taxIdGroupName:'ID Group Name Goes Here'
    },
    activeExpiringExemption:{
        count:3
    },
    nomExemption:{
        count:3
    },
    viewDetails:{
        totalCount:1,
        view:true
    }
},
{
    taxDetails:{
        taxID:'423456789',
        taxIdGroupName:'ID Group Name Goes Here'
    },
    activeExpiringExemption:{
        count:2
    },
    nomExemption:{
        count:2
    },
    viewDetails:{
        totalCount:1,
        view:true
    }
},
{
    taxDetails:{
        taxID:'123456789',
        taxIdGroupName:'ID Group Name Goes Here'
    },
    activeExpiringExemption:{
        count:3
    },
    nomExemption:{
        count:3
    },
    viewDetails:{
        totalCount:1,
        view:true
    }
}

]
export const ExemtionCategories = ['Clinical','Payment Integrity','Payment Integrity - Clinical','Payment Integrity - Non Clinical','Network','Pharmacy','Other'];
export const riskedHcoData=[
    {
        "ProviderSysKey": 1487,
        "HcoName": "SARATOGA HOSPITAL",
        "ProgramName": "DDP Imaging",
        "ProgramValue": 5.36,
        "FiOpptyCount": "112.5K",
        "FacilityAllowedPercentage": "14.32%",
        "cssData": {
            "BgColorCode": "#C40000",
            "BorderColorCode": "#C40000"
        },
        "FiOpptyCountActual": 112537
    },
    {
        "ProviderSysKey": 2779,
        "HcoName": "ST PETERS HEALTH PARTNERS",
        "ProgramName": "SOS Radiology",
        "ProgramValue": 6.39,
        "FiOpptyCount": "87.6K",
        "FacilityAllowedPercentage": "18.3%",
        "cssData": {
            "BgColorCode": "#C40000",
            "BorderColorCode": "#C40000"
        },
        "FiOpptyCountActual": 87588.78
    },
    {
        "ProviderSysKey": 2779,
        "HcoName": "ST PETERS HEALTH PARTNERS",
        "ProgramName": "SOS Colonoscopy",
        "ProgramValue": 5.43,
        "FiOpptyCount": "26.2K",
        "FacilityAllowedPercentage": "18.3%",
        "cssData": {
            "BgColorCode": "#C40000",
            "BorderColorCode": "#C40000"
        },
        "FiOpptyCountActual": 26204.09
    }
]

export const scorecardLegend=[
    {
        "StartIndex": 0,
        "EndIndex": 1.01,
        "StartFIIndex": 0,
        "EndFIIndex": "18K",
        "BgColorCode": "#61D661",
        "BorderColorCode": "#21B01E",
        "FontColorCode": "#4E4E58"
    },
    {
        "StartIndex": 1.02,
        "EndIndex": 1.05,
        "StartFIIndex": "18.1K",
        "EndFIIndex": "18.8K",
        "BgColorCode": "#FFF84F",
        "BorderColorCode": "#DB9C00",
        "FontColorCode": "#4E4E58"
    },
    {
        "StartIndex": 1.05,
        "EndIndex": 99999,
        "StartFIIndex": "18.9K",
        "EndFIIndex": "100K",
        "BgColorCode": "#C40000",
        "BorderColorCode": "#C40000",
        "FontColorCode": "#FFFFFF"
    }
]
export const tableConfigText = {
    taxIdLink: 'tax-id-link',
    taxIdPopupLink: 'tax-id-popup-link',
    fontFamilySemiBold: 'UHCSans-SemiBold, Helvetica, Arial, sans-serif',
    noTaxID: 'Tax ID Not Available',
    noTaxIDName: 'Tax ID Name Not Available',
    FONTFAMILY_SEMIBOLD: 'UHCSans-SemiBold, Helvetica, Arial, sans-serif',
    PROVIDER_NAME_NOT_AVAILABLE: 'Provider Name Not Available',
    NPI_NOT_AVAILABLE: 'Npi Not Available',
    APP_TABLE_CARD: 'app-table-card',
    RLP_TABLE_SMALL_BAR: 'rlp-table-small-bar',
    TREND_DOWN_PATH: 'assets/images/trend-down.svg',
    TREND_UP_PATH: 'assets/images/trend-up.svg'
  };
  export const siteOfCareHeader = 'Tax ID - MPIN - MPIN Name'
  export const singleTin = false;

  export const LoB = {
    LoB: {
      title: 'LoB',
      type: 'dropDown',
      selectedValue: {
        title: 'Commercial',
        value: 'Commercial',
      },
      width: '195px',
      filterOptionsSize: 'large',
      filterType: 2,
      isSorted: true,
      filterDisplayKey: 'value',
      filterValueKey: 'value',
      filterKey: 'Timeperiod',
      key: 'Timeperiod',
      disabled: true,
      options: [],
      activeFilter: false,
      filterDisable: true,
      dropDowndisabled: true,
    },
  };

  export const timePeriod: any = {
    timePeriod: {
      title: 'Timeperiod',
      type: 'dropDown',
      selectedValue: {
        title: '',
        value: '',
      },
      width: '245px',
      filterOptionsSize: 'large',
      filterType: 1,
      isSorted: false,
      filterDisplayKey: 'value',
      filterValueKey: 'value',
      filterKey: 'Timeperiod',
      key: 'Timeperiod',
      disabled: true,
      options: [],
      activeFilter: false,
      filterDisable: false,
    },
  };
  export const trendLayout = {
    status:null,
    cards:[
    {
        "status": null,
        "header":'Impact',
        "title": null,
        "type": "radio-tile-card",
        "total": "$342.8K",
        "width": "160px",
        "enable":true,
        "cardValues": [
            {
                "value": "",
                "name": "Impact",
                "navigateTo": null,
                "linkName": null
            },
            {
                "value": "5$",
                "name": "(At 100% shift rate)",
                "navigateTo": null,
                "linkName": null
            }

        ]
    },
    {
        "status": null,
        "header":"",
        "title": null,
        "type": "radio-tile-card",
        "total": "70 Hours",
        "enable":true,
        "cardValues": [
            {
                "value": "",
                "name": "Fully Insured",
                "navigateTo": null,
                "linkName": null
            },
            {
                "value": "",
                "name": "FI)",
                "navigateTo": null,
                "linkName": null
            },

        ]
    },
    {
        "status": null,
        "header":'',
        "title": null,
        "type": "radio-tile-card",
        "total": "11 Days",
        "enable":true,
        "cardValues": [
            {
                "value": "",
                "name": "Admin Services Only",
                "navigateTo": null,
                "linkName": null
            },
            {
                "value": "",
                "name": "(ASO)",
                "navigateTo": null,
                "linkName": null
            },
        ]
    }

]
};
export const affordabililityStateKeys = {
    radiologyTableData: 'radiologyTableData',
    medSourcingTableData: 'medSourcingTableData',
}
export const providerExperienceStateKeys = {
    averageClaimsData: 'averageClaimsData',
    effortIndexData: 'effortIndexData',
    effortIndexSummaryData: 'effortIndexSummaryData',
    contractYieldData: 'contractYieldData',
    avgClaimTatTrendData: 'avgClaimTatTrendData',
    serviceMetrics: 'serviceMetrics',
    serviceMetricsAppeal: 'serviceMetricsAppeal',
    serviceMetricsDigital: 'serviceMetricsDigital',
    serviceMetricsSecret: 'serviceMetricsSecret',
    serviceMetricsPost: 'serviceMetricsPost',
}

export const myInsightsStateKeys = {
    priorAuthSubmissionData: 'priorAuthSubmissionData',
    priorAuthInsightsData: 'priorAuthInsightsData',
    serviceInteractionsCalls: 'serviceInteractionsCalls',
    serviceInteractionsSmartEdits: 'serviceInteractionsSmartEdits',
    pcmsData: 'pcmsData',
    pocaData: 'pocaData'
}

export const overviewStateKeys = {
    overviewData: 'overviewData',
     topReason: 'topReason',
    topSubReason: 'topSubReason',
    topReasonDOP: 'topReasonDOP',
    topSubReasonDOP: 'topSubReasonDOP',
}

export const reimbursementAppealsStateKeys = {
    appealsDetailsData: 'appealsDetailsData',
}
export const reimbursementReconsiderationsStateKeys = {
    reconsiderationsDetailsData: 'reconsiderationsDetailsData',
}

export const monthsDetails = [
    { name: 'Jan', value: '2024-01-01' },
    { name: 'Feb', value: '2024-02-01' },
    { name: 'Mar', value: '2024-03-01' },
    { name: 'Apr', value: '2024-04-01' },
    { name: 'May', value: '2024-05-01' },
    { name: 'June', value: '2024-06-01' },
    { name: 'July', value: '2024-07-01' },
    { name: 'Aug', value: '2024-08-01' },
    { name: 'Sept', value: '2024-09-01' },
    { name: 'Oct', value: '2024-10-01' },
    { name: 'Nov', value: '2024-11-01' },
    { name: 'Dec', value: '2024-12-01' }
  ]
  export const noResultDetails = 'No results found.  Get started by searching for a parent entity or Genesis ID.'
  export const providerTieringContent = 'Provider Tiering Assignment is based on a Parent Entity and Tax ID’s last 12 months of spend and provider type:'
  export const reportContent = 'List of Documents by Parent Entity'
  export const exemptionKey = {
    topGeoFilter: 'topGeoFilter',
    exemptionAndExclusion:'exemptionAndExclusion',
    totalTins: 'totalTins'
  }
  export const nonPaymentStateKeys = {
    nonPaymentDetails: 'nonPaymentDetails',
    topReasonForClaims: 'topReasonForClaims',
    claimsNonPaymenttrend: 'claimsNonPaymenttrend',
}

export const noDataCardConstants = {
    noDataCardTitle: 'Data Not Available',
    noDataCardDescription: 'Sorry. Please change your filter settings',
}

export const onBoardingKeys= {
    list: 'list',
    save: 'save',
    images: 'images'
  }
export const topPrint = 10

export const genericTitles = {
  PCOR: 'Patient Care Opportunity',
  EDISubbmissionRate: 'EDI Claims Submission Rate',
  SmartEditsResponseTime: 'Smart Edit Claim Response Time - Return Edits',
  NonPayments: 'Non-Payments',
  NetworkManagement: 'Network Management',
  AppropriateDecisionMonitoring: 'Appropriate Decision Monitoring',
  POCA: 'Point of Care Assist',
  EMRSystemTransactions: 'EMR System Transactions',
  ProviderSearch: 'Provider Search',
  GapsInCare: 'Gaps in Care',
  ActivatedTaxIDs: 'Activated Tax IDs',
  PreCheckMyScript: 'PreCheck MyScript',
  ClaimsPaid: 'Claims Paid',
  IntegrationPartnerTransactions: 'Integration Partner Transactions',
  TransactionResults: 'Transaction Results',
  PAQCLU: 'PA Quick Code Look Up',
  ClaimsAppealsSubmitted: 'Claims Appeals Submitted',
  ServiceInteraction: 'Service Interaction',
  SelfServiceEDI: 'Self Service EDI',
  PriorAuthorizations: 'Prior Authorizations',
  SelfServiceSummary: 'Self Service Summary',
  SmartEdits: 'Smart Edits',
  ClaimsNotPaidByVolume: 'Claims Not Paid by Volume',
  ParforLOB: 'Par for LOB',
  FacilityType: 'Facility Type',
  TaxIDName: 'Tax ID Name',
  TaxIDType: 'Tax ID Type',
  OverpaymentsTopReasons: 'Top Reasons for Claim Overpayment',
  noActionTaken: 'No Action Taken',
  status: 'Status',
  TotalAffordabilityImpact: 'Total Affordability Impact'
};
export const externalIndicatorTitleIds = [
  {
    CardTitle: genericTitles.EDISubbmissionRate,
    Category: 'Overview',
    SubCategory: null,
    ExternalIndicatorflag: false,
    TitleId: 110
  },
  {
    CardTitle: 'Estimated Not Paid by Dollar',
    Category: 'Reimbursements',
    SubCategory: genericTitles.NonPayments,
    ExternalIndicatorflag: false,
    TitleId: 120
  },
  {
    CardTitle: 'Appealed Cases_State',
    Category: genericTitles.NetworkManagement,
    SubCategory: genericTitles.AppropriateDecisionMonitoring,
    ExternalIndicatorflag: false,
    TitleId: 137
  },
  {
    CardTitle: 'ICM Recon Overturns_HCO Hospitals in State',
    Category: genericTitles.NetworkManagement,
    SubCategory: genericTitles.AppropriateDecisionMonitoring,
    ExternalIndicatorflag: false,
    TitleId: 276
  },
  {
    CardTitle: 'ICM Recon Overturns_State',
    Category: genericTitles.NetworkManagement,
    SubCategory: genericTitles.AppropriateDecisionMonitoring,
    ExternalIndicatorflag: false,
    TitleId: 274
  },
  {
    CardTitle: 'ICM Recon Overturns_HCO State',
    Category: genericTitles.NetworkManagement,
    SubCategory: genericTitles.AppropriateDecisionMonitoring,
    ExternalIndicatorflag: false,
    TitleId: 275
  },
  {
    CardTitle: 'POCa Service Activations by Tax ID',
    Category: genericTitles.POCA,
    SubCategory: 'Activations',
    ExternalIndicatorflag: false,
    TitleId: 185
  },
  {
    CardTitle: genericTitles.EMRSystemTransactions,
    Category: genericTitles.POCA,
    SubCategory: genericTitles.ProviderSearch,
    ExternalIndicatorflag: true,
    TitleId: 188
  },
  {
    CardTitle: 'Encounters with Open Opportunities',
    Category: genericTitles.POCA,
    SubCategory: genericTitles.GapsInCare,
    ExternalIndicatorflag: false,
    TitleId: 202
  },
  {
    CardTitle: 'Claims Processed',
    Category: 'Overview',
    SubCategory: null,
    ExternalIndicatorflag: false,
    TitleId: 101
  },
  {
    CardTitle: 'Initial LOC Determination Cases_State',
    Category: genericTitles.NetworkManagement,
    SubCategory: genericTitles.AppropriateDecisionMonitoring,
    ExternalIndicatorflag: false,
    TitleId: 131
  },
  {
    CardTitle: genericTitles.ActivatedTaxIDs,
    Category: genericTitles.POCA,
    SubCategory: 'Eligibility',
    ExternalIndicatorflag: true,
    TitleId: 191
  },
  {
    CardTitle: 'Switches Over Time',
    Category: genericTitles.POCA,
    SubCategory: genericTitles.PreCheckMyScript,
    ExternalIndicatorflag: false,
    TitleId: 205
  },
  {
    CardTitle: genericTitles.ClaimsPaid,
    Category: 'Reimbursements',
    SubCategory: 'Payments',
    ExternalIndicatorflag: false,
    TitleId: 117
  },
  {
    CardTitle: 'Claims Yield',
    Category: 'Reimbursements',
    SubCategory: 'Payments',
    ExternalIndicatorflag: false,
    TitleId: 118
  },
  {
    CardTitle: 'MCR Reconsideration Cases_HCO State',
    Category: genericTitles.NetworkManagement,
    SubCategory: genericTitles.AppropriateDecisionMonitoring,
    ExternalIndicatorflag: false,
    TitleId: 133
  },
  {
    CardTitle: 'Imaging Provider Details',
    Category: 'Performance',
    SubCategory: 'Imaging',
    ExternalIndicatorflag: true,
    TitleId: 179
  },
  {
    CardTitle: genericTitles.IntegrationPartnerTransactions,
    Category: genericTitles.POCA,
    SubCategory: genericTitles.ProviderSearch,
    ExternalIndicatorflag: false,
    TitleId: 189
  },
  {
    CardTitle: genericTitles.EMRSystemTransactions,
    Category: genericTitles.POCA,
    SubCategory: 'Eligibility',
    ExternalIndicatorflag: false,
    TitleId: 193
  },
  {
    CardTitle: genericTitles.EMRSystemTransactions,
    Category: genericTitles.POCA,
    SubCategory: genericTitles.PAQCLU,
    ExternalIndicatorflag: false,
    TitleId: 197
  },
  {
    CardTitle: genericTitles.ClaimsAppealsSubmitted,
    Category: 'Overview',
    SubCategory: null,
    ExternalIndicatorflag: false,
    TitleId: 105
  },
  {
    CardTitle: 'Prior Authorizations Requested',
    Category: 'Overview',
    SubCategory: null,
    ExternalIndicatorflag: true,
    TitleId: 107
  },
  {
    CardTitle: 'Appealed Cases_HCO Hospitals in State',
    Category: genericTitles.NetworkManagement,
    SubCategory: genericTitles.AppropriateDecisionMonitoring,
    ExternalIndicatorflag: false,
    TitleId: 138
  },
  {
    CardTitle: 'Pharmacy Preferred Tier Prescribing Rate',
    Category: 'Performance',
    SubCategory: 'Summary',
    ExternalIndicatorflag: true,
    TitleId: 167
  },
  {
    CardTitle: genericTitles.ClaimsPaid,
    Category: 'Reimbursements',
    SubCategory: 'Summary',
    ExternalIndicatorflag: false,
    TitleId: 113
  },
  {
    CardTitle: 'Top Reasons for Claims Non-Payments',
    Category: 'Reimbursements',
    SubCategory: genericTitles.NonPayments,
    ExternalIndicatorflag: false,
    TitleId: 122
  },
  {
    CardTitle: 'Claims Appeals Overturned Rate',
    Category: 'Reimbursements',
    SubCategory: 'Appeals',
    ExternalIndicatorflag: false,
    TitleId: 127
  },
  {
    CardTitle: genericTitles.EDISubbmissionRate,
    Category: genericTitles.ServiceInteraction,
    SubCategory: genericTitles.SelfServiceEDI,
    ExternalIndicatorflag: false,
    TitleId: 157
  },
  {
    CardTitle: 'Calls by Call Type',
    Category: genericTitles.ServiceInteraction,
    SubCategory: 'Calls',
    ExternalIndicatorflag: true,
    TitleId: 163
  },
  {
    CardTitle: 'Preferred Specialist Referral Rate',
    Category: 'Performance',
    SubCategory: 'Summary',
    ExternalIndicatorflag: true,
    TitleId: 165
  },
  {
    CardTitle: 'Lower Cost Surgery Center Use by Ordering Tax ID, Provider and Specialty',
    Category: 'Performance',
    SubCategory: 'Surgery',
    ExternalIndicatorflag: true,
    TitleId: 183
  },
  {
    CardTitle: 'Transactions and Users',
    Category: genericTitles.POCA,
    SubCategory: genericTitles.PAQCLU,
    ExternalIndicatorflag: false,
    TitleId: 196
  },
  {
    CardTitle: 'Average Claim Processing Days',
    Category: 'Reimbursements',
    SubCategory: 'Summary',
    ExternalIndicatorflag: false,
    TitleId: 112
  },
  {
    CardTitle: 'Claims Appeals Overturned',
    Category: 'Reimbursements',
    SubCategory: 'Summary',
    ExternalIndicatorflag: false,
    TitleId: 116
  },
  {
    CardTitle: 'Claims Non-Payments Trend',
    Category: 'Reimbursements',
    SubCategory: genericTitles.NonPayments,
    ExternalIndicatorflag: false,
    TitleId: 123
  },
  {
    CardTitle: 'Initial LOC Determination Cases_HCO Hospitals in State',
    Category: genericTitles.NetworkManagement,
    SubCategory: genericTitles.AppropriateDecisionMonitoring,
    ExternalIndicatorflag: false,
    TitleId: 132
  },
  {
    CardTitle: 'Prior Authorization Approval Rate',
    Category: genericTitles.PriorAuthorizations,
    SubCategory: null,
    ExternalIndicatorflag: true,
    TitleId: 144
  },
  {
    CardTitle: 'Talk Time by Call Type',
    Category: genericTitles.ServiceInteraction,
    SubCategory: 'Calls',
    ExternalIndicatorflag: false,
    TitleId: 164
  },
  {
    CardTitle: 'Prior Authorization Requested',
    Category: genericTitles.PriorAuthorizations,
    SubCategory: null,
    ExternalIndicatorflag: false,
    TitleId: 143
  },
  {
    CardTitle: 'Digital Solutions Adoption Rate',
    Category: genericTitles.ServiceInteraction,
    SubCategory: genericTitles.SelfServiceSummary,
    ExternalIndicatorflag: false,
    TitleId: 149
  },
  {
    CardTitle: 'Reduce Claim Processing Time by',
    Category: genericTitles.ServiceInteraction,
    SubCategory: genericTitles.SelfServiceSummary,
    ExternalIndicatorflag: false,
    TitleId: 156
  },
  {
    CardTitle: 'Smart Edit Top Reasons',
    Category: genericTitles.ServiceInteraction,
    SubCategory: genericTitles.SmartEdits,
    ExternalIndicatorflag: false,
    TitleId: 162
  },
  {
    CardTitle: 'Smart Edit Details',
    Category: genericTitles.ServiceInteraction,
    SubCategory: genericTitles.SmartEdits,
    ExternalIndicatorflag: true,
    TitleId: 222
  },
  {
    CardTitle: 'Preferred Tier Prescribing by Tax ID, Provider and Specialty',
    Category: 'Performance',
    SubCategory: 'Prescribing',
    ExternalIndicatorflag: true,
    TitleId: 177
  },
  {
    CardTitle: 'Claims Not Paid',
    Category: 'Overview',
    SubCategory: null,
    ExternalIndicatorflag: false,
    TitleId: 103
  },
  {
    CardTitle: 'Top Claims Appeals Overturn Reasons',
    Category: 'Overview',
    SubCategory: null,
    ExternalIndicatorflag: false,
    TitleId: 106
  },
  {
    CardTitle: 'Other Reversals_State',
    Category: genericTitles.NetworkManagement,
    SubCategory: genericTitles.AppropriateDecisionMonitoring,
    ExternalIndicatorflag: false,
    TitleId: 140
  },
  {
    CardTitle: 'Medicare Annual Care Visits Completion Rate',
    Category: genericTitles.PCOR,
    SubCategory: null,
    ExternalIndicatorflag: false,
    TitleId: 147
  },
  {
    CardTitle: 'UHC Provider Portal & EDI to Call Ratio',
    Category: genericTitles.ServiceInteraction,
    SubCategory: genericTitles.SelfServiceSummary,
    ExternalIndicatorflag: false,
    TitleId: 150
  },
  {
    CardTitle: 'Reduce Calls & Operating Costs by',
    Category: genericTitles.ServiceInteraction,
    SubCategory: genericTitles.SelfServiceSummary,
    ExternalIndicatorflag: false,
    TitleId: 153
  },
  {
    CardTitle: 'Lab Network Use',
    Category: 'Performance',
    SubCategory: 'Labs',
    ExternalIndicatorflag: true,
    TitleId: 172
  },
  {
    CardTitle: 'Imaging Provider Use',
    Category: 'Performance',
    SubCategory: 'Imaging',
    ExternalIndicatorflag: true,
    TitleId: 178
  },
  {
    CardTitle: 'Lower Cost Imaging Provider Use by Ordering Tax ID, Provider and Specialty',
    Category: 'Performance',
    SubCategory: 'Imaging',
    ExternalIndicatorflag: true,
    TitleId: 180
  },
  {
    CardTitle: genericTitles.ActivatedTaxIDs,
    Category: genericTitles.POCA,
    SubCategory: genericTitles.ProviderSearch,
    ExternalIndicatorflag: true,
    TitleId: 186
  },
  {
    CardTitle: 'Transactions and Users Over Time',
    Category: genericTitles.POCA,
    SubCategory: 'Eligibility',
    ExternalIndicatorflag: false,
    TitleId: 192
  },
  {
    CardTitle: genericTitles.ActivatedTaxIDs,
    Category: genericTitles.POCA,
    SubCategory: genericTitles.PreCheckMyScript,
    ExternalIndicatorflag: false,
    TitleId: 203
  },
  {
    CardTitle: 'Alternative Medication Displays & Switches Made',
    Category: genericTitles.POCA,
    SubCategory: genericTitles.PreCheckMyScript,
    ExternalIndicatorflag: false,
    TitleId: 204
  },
  {
    CardTitle: 'Claims Payment Integrity',
    Category: 'Reimbursements',
    SubCategory: 'Medical Records Coding Review',
    ExternalIndicatorflag: false,
    TitleId: 129
  },
  {
    CardTitle: 'Digital Solutions Adoption Rate',
    Category: 'Overview',
    SubCategory: null,
    ExternalIndicatorflag: false,
    TitleId: 109
  },
  {
    CardTitle: "Save Your Staff's Time by",
    Category: genericTitles.ServiceInteraction,
    SubCategory: genericTitles.SelfServiceSummary,
    ExternalIndicatorflag: false,
    TitleId: 154
  },
  {
    CardTitle: 'Reduce Reconsideration Processing by',
    Category: genericTitles.ServiceInteraction,
    SubCategory: genericTitles.SelfServiceSummary,
    ExternalIndicatorflag: false,
    TitleId: 155
  },
  {
    CardTitle: 'Smart Edits Claims Returned',
    Category: genericTitles.ServiceInteraction,
    SubCategory: genericTitles.SmartEdits,
    ExternalIndicatorflag: false,
    TitleId: 160
  },
  {
    CardTitle: 'Preferred Lab Network Use Rate',
    Category: 'Performance',
    SubCategory: 'Summary',
    ExternalIndicatorflag: true,
    TitleId: 166
  },
  {
    CardTitle: 'Tier Prescribing',
    Category: 'Performance',
    SubCategory: 'Prescribing',
    ExternalIndicatorflag: true,
    TitleId: 175
  },
  {
    CardTitle: 'Surgical Center Use',
    Category: 'Performance',
    SubCategory: 'Surgery',
    ExternalIndicatorflag: true,
    TitleId: 181
  },
  {
    CardTitle: 'POCa Service Activations by Number of Tax IDs',
    Category: genericTitles.POCA,
    SubCategory: 'Activations',
    ExternalIndicatorflag: true,
    TitleId: 184
  },
  {
    CardTitle: 'Provider Searches by Tax ID, Provider',
    Category: genericTitles.POCA,
    SubCategory: genericTitles.ProviderSearch,
    ExternalIndicatorflag: false,
    TitleId: 190
  },
  {
    CardTitle: 'Quality Star Rating',
    Category: genericTitles.PCOR,
    SubCategory: null,
    ExternalIndicatorflag: false,
    TitleId: 148
  },
  {
    CardTitle: genericTitles.ActivatedTaxIDs,
    Category: genericTitles.POCA,
    SubCategory: genericTitles.GapsInCare,
    ExternalIndicatorflag: true,
    TitleId: 200
  },
  {
    CardTitle: 'Prior Authorizations Approval Rate',
    Category: 'Overview',
    SubCategory: null,
    ExternalIndicatorflag: false,
    TitleId: 108
  },
  {
    CardTitle: 'Top Reasons for Claims Non-Payments',
    Category: 'Overview',
    SubCategory: null,
    ExternalIndicatorflag: false,
    TitleId: 104
  },
  {
    CardTitle: 'Other Reversals_HCO State',
    Category: genericTitles.NetworkManagement,
    SubCategory: genericTitles.AppropriateDecisionMonitoring,
    ExternalIndicatorflag: false,
    TitleId: 139
  },
  {
    CardTitle: 'Top Reasons for Prior Authorizations Not Approved',
    Category: genericTitles.PriorAuthorizations,
    SubCategory: null,
    ExternalIndicatorflag: false,
    TitleId: 145
  },
  {
    CardTitle: 'Specialist Referrals',
    Category: 'Performance',
    SubCategory: 'Referrals',
    ExternalIndicatorflag: true,
    TitleId: 170
  },
  {
    CardTitle: genericTitles.IntegrationPartnerTransactions,
    Category: genericTitles.POCA,
    SubCategory: genericTitles.PAQCLU,
    ExternalIndicatorflag: false,
    TitleId: 198
  },
  {
    CardTitle: 'Claims Processed',
    Category: 'Reimbursements',
    SubCategory: 'Summary',
    ExternalIndicatorflag: false,
    TitleId: 111
  },
  {
    CardTitle: genericTitles.ClaimsAppealsSubmitted,
    Category: 'Reimbursements',
    SubCategory: 'Summary',
    ExternalIndicatorflag: false,
    TitleId: 115
  },
  {
    CardTitle: 'Claims Non-Payments Details',
    Category: 'Reimbursements',
    SubCategory: genericTitles.NonPayments,
    ExternalIndicatorflag: false,
    TitleId: 124
  },
  {
    CardTitle: 'Claims Appeals Overturned',
    Category: 'Reimbursements',
    SubCategory: 'Appeals',
    ExternalIndicatorflag: false,
    TitleId: 126
  },
  {
    CardTitle: 'Initial LOC Determination Cases_HCO State',
    Category: genericTitles.NetworkManagement,
    SubCategory: genericTitles.AppropriateDecisionMonitoring,
    ExternalIndicatorflag: false,
    TitleId: 130
  },
  {
    CardTitle: 'MCR Reconsideration Cases_HCO Hospitals in State',
    Category: genericTitles.NetworkManagement,
    SubCategory: genericTitles.AppropriateDecisionMonitoring,
    ExternalIndicatorflag: false,
    TitleId: 135
  },
  {
    CardTitle: 'Paperless Delivery',
    Category: genericTitles.ServiceInteraction,
    SubCategory: genericTitles.SelfServiceSummary,
    ExternalIndicatorflag: false,
    TitleId: 151
  },
  {
    CardTitle: 'Payments by Submission Method',
    Category: genericTitles.ServiceInteraction,
    SubCategory: genericTitles.SelfServiceEDI,
    ExternalIndicatorflag: false,
    TitleId: 158
  },
  {
    CardTitle: 'Preferred Lab Use by Ordering Tax ID, Provider and Specialty',
    Category: 'Performance',
    SubCategory: 'Labs',
    ExternalIndicatorflag: true,
    TitleId: 174
  },
  {
    CardTitle: genericTitles.ActivatedTaxIDs,
    Category: genericTitles.POCA,
    SubCategory: genericTitles.PAQCLU,
    ExternalIndicatorflag: false,
    TitleId: 195
  },
  {
    CardTitle: 'Claims Summary',
    Category: 'Reimbursements',
    SubCategory: 'Payments',
    ExternalIndicatorflag: false,
    TitleId: 119
  },
  {
    CardTitle: 'Top Claims Appeals Overturn Reasons',
    Category: 'Reimbursements',
    SubCategory: 'Appeals',
    ExternalIndicatorflag: false,
    TitleId: 128
  },
  {
    CardTitle: 'Lower Cost Imaging Provider Use',
    Category: 'Performance',
    SubCategory: 'Summary',
    ExternalIndicatorflag: true,
    TitleId: 168
  },
  {
    CardTitle: 'Lab Network Details',
    Category: 'Performance',
    SubCategory: 'Labs',
    ExternalIndicatorflag: true,
    TitleId: 173
  },
  {
    CardTitle: 'Transactions by Result Category',
    Category: genericTitles.POCA,
    SubCategory: genericTitles.PAQCLU,
    ExternalIndicatorflag: false,
    TitleId: 199
  },
  {
    CardTitle: genericTitles.ClaimsPaid,
    Category: 'Overview',
    SubCategory: null,
    ExternalIndicatorflag: false,
    TitleId: 102
  },
  {
    CardTitle: genericTitles.ClaimsNotPaidByVolume,
    Category: 'Reimbursements',
    SubCategory: 'Summary',
    ExternalIndicatorflag: false,
    TitleId: 114
  },
  {
    CardTitle: genericTitles.ClaimsAppealsSubmitted,
    Category: 'Reimbursements',
    SubCategory: 'Appeals',
    ExternalIndicatorflag: false,
    TitleId: 125
  },
  {
    CardTitle: 'Appealed Cases_HCO State',
    Category: genericTitles.NetworkManagement,
    SubCategory: genericTitles.AppropriateDecisionMonitoring,
    ExternalIndicatorflag: false,
    TitleId: 136
  },
  {
    CardTitle: genericTitles.EDISubbmissionRate,
    Category: genericTitles.ServiceInteraction,
    SubCategory: genericTitles.SelfServiceSummary,
    ExternalIndicatorflag: false,
    TitleId: 152
  },
  {
    CardTitle: 'EDI Claims Submission Rate Trend',
    Category: genericTitles.ServiceInteraction,
    SubCategory: genericTitles.SelfServiceEDI,
    ExternalIndicatorflag: false,
    TitleId: 159
  },
  {
    CardTitle: 'Smart Edits Repaired & Resubmitted Response Time',
    Category: genericTitles.ServiceInteraction,
    SubCategory: genericTitles.SmartEdits,
    ExternalIndicatorflag: false,
    TitleId: 161
  },
  {
    CardTitle: genericTitles.IntegrationPartnerTransactions,
    Category: genericTitles.POCA,
    SubCategory: 'Eligibility',
    ExternalIndicatorflag: false,
    TitleId: 194
  },
  {
    CardTitle: genericTitles.TransactionResults,
    Category: genericTitles.POCA,
    SubCategory: 'Eligibility',
    ExternalIndicatorflag: false,
    TitleId: 209
  },
  {
    CardTitle: 'Encounters and Users by NPI',
    Category: genericTitles.POCA,
    SubCategory: genericTitles.GapsInCare,
    ExternalIndicatorflag: false,
    TitleId: 201
  },
  {
    CardTitle: genericTitles.ClaimsNotPaidByVolume,
    Category: 'Reimbursements',
    SubCategory: genericTitles.NonPayments,
    ExternalIndicatorflag: false,
    TitleId: 121
  },
  {
    CardTitle: 'MCR Reconsideration Cases_State',
    Category: genericTitles.NetworkManagement,
    SubCategory: genericTitles.AppropriateDecisionMonitoring,
    ExternalIndicatorflag: false,
    TitleId: 134
  },
  {
    CardTitle: 'Year over Year metric card',
    Category: genericTitles.NetworkManagement,
    SubCategory: 'Level of Care',
    ExternalIndicatorflag: false,
    TitleId: 142
  },
  {
    CardTitle: 'Lower Cost Surgical Center Use',
    Category: 'Performance',
    SubCategory: 'Summary',
    ExternalIndicatorflag: true,
    TitleId: 169
  },
  {
    CardTitle: 'Preferred Specialist Referrals by Tax ID, Provider and Speciality',
    Category: 'Performance',
    SubCategory: 'Referrals',
    ExternalIndicatorflag: true,
    TitleId: 171
  },
  {
    CardTitle: 'Tier Prescribing by Medication Type',
    Category: 'Performance',
    SubCategory: 'Prescribing',
    ExternalIndicatorflag: true,
    TitleId: 176
  },
  {
    CardTitle: 'Surgical Center Use Details',
    Category: 'Performance',
    SubCategory: 'Surgery',
    ExternalIndicatorflag: true,
    TitleId: 182
  },
  {
    CardTitle: genericTitles.TransactionResults,
    Category: 'Performance',
    SubCategory: 'Surgery',
    ExternalIndicatorflag: true,
    TitleId: 198
  },
  {
    CardTitle: 'P2P Adverse Determination Cases_HCO State',
    Category: genericTitles.NetworkManagement,
    SubCategory: genericTitles.AppropriateDecisionMonitoring,
    ExternalIndicatorflag: false,
    TitleId: 278
  },
  {
    CardTitle: 'P2P Adverse Determination Cases_HCO Hospitals in State',
    Category: genericTitles.NetworkManagement,
    SubCategory: genericTitles.AppropriateDecisionMonitoring,
    ExternalIndicatorflag: false,
    TitleId: 279
  },
  {
    CardTitle: 'P2P Adverse Determination Cases_State',
    Category: genericTitles.NetworkManagement,
    SubCategory: genericTitles.AppropriateDecisionMonitoring,
    ExternalIndicatorflag: false,
    TitleId: 277
  }
];

export const MetricidService = {MetricIDs : {
      TopReasonsforClaimsNonPayment: '100',
      ClaimAppealsOverturnRate: '101',
      TopClaimAppealsOverturnReasons: '102',
      ClaimsPaid: '103',
      ClaimsYield: '104',
      ClaimsAppealsSubmitted: '105',
      ClaimAppealsOverturned: '106',
      ClaimsNotPaid: '107',
      ClaimsNonPaymentRate: '108',
      TotalClaimsSubmitted: '109',
      ActualAllowed: '110',
      ExpectedAllowed: '111',
      ClaimsPaidBreakdown: '112',
      ClaimsPaymentIntegrity: '116',
      OverpaymentsTopReason: '1005',
      TotalNumberofClaimsSubmitted: '114',
      AverageClaimProcessingDays: '115',
      PaymentIntegrityCodeReviewResults: '116',
      PaymentIntegrityRecordsReceivedvsAwaiting: '117',
      PaymentIntegrityRecordsRequestedbyUHC: '118',
      EstimatedNotPaidByDollar: '120',
      EstimatedNotPaidByVolume: '121',
      MedicareStarRating: '200',
      // PriorAuthorizationRequested: '201',
      PriorAuthorizationRequested: '211',
      PriorAuthTurnaroundTime: '201',
      TopReasonsforPriorAuthorizationsNotApproved: '202',
      // PriorAuthorizationApprovalRate: '203',
      PriorAuthorizationApprovalRate: '212',
      CaseSubmissionsOverTime: '203',
      MedicareRetirementAnnualCareVisitsCompletionRateAll: '204',
      MedicareRetirementAnnualCareVisitsCompletionRateDiabetic: '204',
      QualityStarRatings: '206',
      PriorAuthorizationSavingsOpportunity: '209',
      PriorAuthorizationSubmissionDetails: '210',
      CaseSubmissionChannels: '213',
      TotalCalls: '300',
      PaperlessDelivery: '301',
      LinkEDItoCallRatio: '302',
      CallsbyCallType: '303',
      TalkTimebyCallType: '304',
      SelfServiceAdoptionRate: '305',
      ReduceReconsiderationProcessingBy: '306',
      SaveyourStaffsTimeBy: '307',
      ReduceCallsOperatingCostsBy: '308',
      ReduceClaimProcessingTimeBy: '309',
      PreferredSpecialistReferralRate: '401',
      PreferredLabNetworkUseRate: '403',
      PreferredSpecialistReferrals: '401',
      PharmacyPreferredTierPrescribing: '402',
      PreferredLabNetworkUse: '403',
      POCaServiceActivated: '335',
      PaymentsBySubmission: '310',
      ClaimsAverageTurnaroundTimetoPayment: 'NA',
      ClaimsSubmissions: 'NA',
      ClaimsPayments: 'NA',
      ClaimsNonPayments: 'NA',
      ClaimsAppeals: 'NA',
      ClaimsRecon: 'NA',
      PriorAuthorizationApproval: 'NA',
      ClaimsNonPaymentTrend: '119',
      ClaimsAppealsSubmittedTrend: 'NA',
      SmartEditsReturned: '314',
      SmartEditsResubmitted: '315',
      SmartEditsReturnedReasons: '316',
      FullAdverseDeterminationCases: '317',
      SmartEditOverTime: '1102',
      MCRReconsiderationCases: '318',
      AppealedCases: '319',
      OtherReversals: '320',
      EDICardSummary: '340',
      EDICardMainPage: '340',
      LOCMetrics: '344,345,346,347,348,349,350',
      LabNetworkUse: '407',
      SpecialistReferrals: '406',
      TierPrescribing: '408',
      LabsUsebyServicingFacilitiesandType: '411',
      PrescribingbyMedicationType: '412',
      ImagingServicesbyCenterandImagingType: '413',
      ImagingProviderDetails: '413',
      SurgerybyTypeandSurgeryCenter: '414',
      SurgicalCenterUseDetails: '414',
      // LowerCostImagingCenterUse: '404',
      LowerCostImagingProviderUseRate: '404',
      // LowerCostNonEmergentSurgeryFacilityUse: '405',
      LowerCostSurgicalCenterUseRate: '405',
      ImagingCenterUse: '409',
      ImagingProviderUse: '409',
      // NonEmergentSurgeryCenterUse: '410',
      SurgicalCenterUse: '410',
      POCAEligibilityTransactionsAndUsers: '702,703,704',
      POCAEligibilityEmrTransactions: '705',
      POCAEligibilitySystemIntegrations: '706',
      POCAProviderSearchTransactionsAndUsers: '802,803,804',
      AlternativeMedicationDisplaysSwitchesMade: '342',
      SwitchesOverTime: '343',
      SwitchRateDetail: '505',
      VBCActiveProgramsCard: '1201',
      VBCPayoutDataMetric: '1202',
      AlternativeMedicationsSwitchesMadeByLineOfBusinessTaxIDProviderAndSpecialty: '506',
      PACodelookupTransactionsandUsers: '601,602,603',
      POCAEligibilityTransactionsOverTime: '702',
      POCAEligibilityUsersOverTime: '703',
      POCAProviderSearchTransactionsOverTime: '802',
      POCAProviderSearchUsersOverTime: '803',
      PACodelookupTransactionsOverTime: '601',
      PACodelookupUsersOverTime: '602',
      QCEncounterOverTime: '500',
      QCUsersOverTime: '507',
      ProviderSearchesByTaxIDandProvider: '807',
      LowerCostMedicationOpportunities: '1003',
      UHCPreferredUtilizationOpportunities: '1001',
      PriorAuthorizationSubmissions: '1000',
      PointofCareAssistMetrics: '1002',
      PriorAuthorizationBanner: '1004',
      PriorAuthQuickCodeLookupInsight: '607',
      CSTransactionsOverTime: '951',
      CSUsersOverTime: '952',
      AppealsTrend: '129',
      AppealsDetails: '1006',
      claimsPaidActive: '1007',
      claimsPaidInActive: '1008',
      marketShareDetails: '1301',
      VBCInflators: '1203',
      TopReasonsforClaimsNonPaymentGS: '1900',
      ClaimAppealsOverturnRateGS: '1901',
      ClaimsPaidGS: '1902',
      ActualAllowedGS: '1903',
      ClaimsSummaryGS: '1904',
      MedicalRecordsReceivedAwaitingSubmissionGS: '1905',
      TopClaimsAppealsOverturnReasonsGS: '1906',
      TotalNumberofClaimsSubmittedGS: '1907',
      ExpectedAllowedGS: '1908',
      PIMedicalRecordCodingReviewGS: '1909',
      PIMedicalRecordsRequestedbyUHCGS: '1910',
      ClaimsYieldGS: '1911',
      ClaimAppealsOverturnedGS: '1912',
      ClaimsNotPaidGS: '1913',
      ClaimsAppealsSubmittedGS: '1914',
      ClaimsNonpaymentRateGS: '1915',
      ClaimsProcessedGS: '1916',
      ClaimsNonPaymentTrendGS: '1917',
      EstimatedNotPaidbyDollarGS: '1918',
      ClaimsNotPaidbyVolumeGS: '1919',
      AverageClaimProcessingDaysGS: '1920',
      NonPaymentDetailsGS: '1921',
      CompleteandPartialClaimsNonPaymentsTrendGS: '1922',
      ReconsiderationDetailsGS: '1923',
      PendingReconsiderationsbyVolumeGS: '1924',
      ReconsiderationOutcomesbyVolumeGS: '1925',
      ReconsiderationAverageTurnAroundTimesGS: '1926',
      TopReasonsforClaimsOverpaymentGS: '1927',
      OverpaymentDetailsGS: '1928',
      ClaimsPaidActiveGS: '1929',
      ClaimsPaidNotActiveGS: '1930',
      PaymentIntegrityEvaluations: '2000',
      PaymentIntegrityEvaluationDetails: '2001',
      PaymentIntegrityIdentifiedAdjustments: '2002',
      PaymentIntegrityMedicalRecords: '2003',
      PaymentIntegrityAuditReason: '2004'
    },MetricName : {
      HRLTaxidMetricName: 'Hospital Reference Lab'
    }

}

export const sessionStorageKeys = {
  hiVolumetTinKey: 'HIVOLUMETINFLOW'
}

export const UI_STRINGS = {
  CUSTOM_DAY_PICKER: 'Custom Day Picker',
  CUSTOM_MONTH_PICKER: 'Custom Month Picker',
  FILTERS_TITLE: 'Filters',
  IS_ELITE: 'IsElite'
};